var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLandGriechenland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 15,
    fill: "#0069b3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.848,13.019C4.264,11.84 4.826,10.718 5.521,9.679L8.801,9.679L8.801,6.155C9.824,5.358 10.947,4.697 12.14,4.189L12.14,9.679L17.999,9.679L17.999,13.019L12.14,13.019L12.14,19.698L32.905,19.698C32.776,20.838 32.517,21.958 32.132,23.038L3.868,23.038C3.483,21.958 3.224,20.838 3.095,19.698L8.801,19.698L8.801,13.019L3.848,13.019ZM30.48,26.319C29.638,27.581 28.609,28.707 27.433,29.659L8.567,29.659C7.391,28.707 6.363,27.581 5.52,26.319L30.48,26.319ZM17.999,13.019L32.152,13.019C32.533,14.1 32.787,15.22 32.911,16.359L17.999,16.359L17.999,13.019ZM17.999,9.679L17.999,6.34L27.433,6.34C28.608,7.292 29.637,8.418 30.479,9.679L17.999,9.679Z",
    fill: "#f5f5f5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandGriechenland);
export default __webpack_public_path__ + "static/media/land_griechenland.2353f622108f4625d499472564596c3f.svg";
export { ForwardRef as ReactComponent };